import ali from '../../assets/whygdgszabist/ali.png'
import Mujeeb from '../../assets/whygdgszabist/mujeeb.png'
import Mufaddal from '../../assets/whygdgszabist/mufaddal.png'
import arsalan from '../../assets/whygdgszabist/arsalan.png'
const sliderData = [
  {
    id: 1,
    imgSrc: ali,
    name: "Ali Asar Khowaja, Flutter Developer",
    designation: "Community Mentor And Lead (2023-2024) GDGoC SZABIST Karachi",
    whatSaid:
      "Being a mentor at GDSC allowed me to share my industry knowledge and inspire students to tackle real-world challenges with confidence.",
    theme: {
      Color: "#34a853",
      backgroundColor: "#f2f9f4",
    },
  },
  {
    id: 2,
    imgSrc: Mujeeb,
    name: "Mujeeb Ur Rehman, React Developer",
    designation: "Lead 2025-2026, GDGoC SZABIST Karachi",
    whatSaid:
    "Communities like GDG empower developers to come together, learn, and build solutions that make a difference.",
    theme: {
      Color: "#d68400",
      backgroundColor: "#fffbf0",
    },
  },
  {
    id: 3,
    imgSrc: Mufaddal,
    name: "Mufaddal Hatim, Software Engineer",
    designation: "x-Community Lead GDGoC SZABIST Karachi",
    whatSaid:
    "GDGoC is more than a community. It’s a place where I learned, shared ideas, and grew as a tech leader. The experience has been truly rewarding.",
    theme: {
      Color: "#34a853",
      backgroundColor: "#f2f9f4",
    },
  },
  {
    id: 4,
    imgSrc: arsalan,
    name: "Arsalan Ayaz, Flutter Developer",
    designation: "Lead 2024-2025, GDGoC SZABIST Karachi",
    whatSaid:
    "Leading GDGoC at SZABIST has been an incredible journey—fostering innovation, mentoring peers, and building a community that thrives on learning and collaboration.",
    theme: {
      Color: "#d68400",
      backgroundColor: "#fffbf0",
    },
  },
  
];

export default sliderData;
